import icon from "../../assets/clients.svg";
import type { Property } from "../../types";

export const connectedDevices: Property = {
  id: "connectedDevices",
  title: "connectedDevices.title",
  icon,
};
